
import {Vue} from "vue-class-component";
import {PromocodeDto} from "@/types/promocodes";
import ModulePromocodes from "@/store/promocodes";

export default class Promocodes extends Vue{
    private allPromocodes: PromocodeDto[] = [];
    private headers = [
        { title: 'Promocode', value: 'promocode' },
        { title: 'Description', value: 'description' },
        { title: 'Percentage, %', value: 'discountPercentage' },
        { title: 'Discount amount', value: 'discountAmount' },
        { title: 'Valid until', value: 'validUntil' },
        { title: 'Valid amount', value: 'validAmount' },
        { title: 'Used amount', value: 'usedAmount' }
    ];

    async mounted() {
        this.allPromocodes = await ModulePromocodes.getAllSpecialistPromocodes();
    }
}
